import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLettering = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 123.8 61.1",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#0a0a0a",
			d: "M42.8 45c-.5 2-1.8 3.7-1.2 6 .6-.6 1-1.2 1.3-2 .5-1 1-2 1.7-2.9.2-.2.4-.6.8-.4s.2.5.2.7c-.1 1.2 0 2.3.2 3.4.1.4.3.8.7 1.1.1-2 1.1-3.9 2.7-5.1 1-.8 1.3-.8 2.3 0 .8-1.6 1.1-3.4 2.2-4.9.5.5.1.8 0 1.1-.8 1.9-1.5 4-2 6-.1.6-.1 1.2-.1 1.8-.1.8.5 1.1 1.2 1.4-1.4.7-1.9 0-2-2.5-.7.9-1.4 1.8-2.1 2.6-.9.8-2.2.8-3.1 0-.2-.2-.4-.5-.5-.9-.3-.9-.2-1.9-.5-3-.5 1.1-1.1 2.3-1.7 3.5-.3.6-.6 1.2-1.4 1s-.9-1-.9-1.6c0-1.4.4-2.7 1-3.9-2 .7-2.7 1.7-2.7 3.6.2 2.1-.1 4.3-.7 6.4-.2.6-.5 1.2-1.1 1.2s-1-.6-1.2-1.2c-.4-1.2-.4-2.5 0-3.6q.15-.9.6-1.8c.9-1.6 1.8-3.2 1.8-5.1 0-.3.1-.5.4-.5h.1v2.5c1-1.5 2.7-1.9 4-2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#060606",
			d: "M63.5 33.6c1.5-.3 2.4-1.5 3.7-1.8-.9 1.1-2 2-3.3 2.5-.7.3-1 0-1.1-.7-.1-.9.3-1.8.3-2.8-.6.6-1.1 1.3-1.7 1.9-.4.4-.8 1.1-1.6.8s-.2-1-.5-1.7c-.6.9-1.5 1.5-2.5 1.7-1.1.3-2.2-.4-2.4-1.4-.4.3-.7.6-1.1.8-1.2.8-2.1.4-2.2-1.1 0-1.4.3-2.9 1-4.1.3-.7.7-1.3 1.1-2-1.5-.2-3 .1-4.5-.4 2.7 0 5.5.1 7.8-1.8-.2.9-1.1.9-1.5 1.6l1.5.2c-.2.5-.6.4-.8.3-1.2-.2-1.9.4-2.4 1.4-.8 1.4-1.3 3-1.3 4.6 0 .7.2.9.8.5.9-.4 1.7-1.1 2.3-2 .7-1.4 1.9-2.5 3.3-3.2.5-.3 1.1-.2 1.5.3s.2 1-.1 1.4c-.7 1.1-1.8 1.7-3.1 1.8-.6-.1-1.1.3-1.3.8-.2.4-.3.9.1 1.2s1 .4 1.5.2c1.2-.6 2.4-1.1 3.1-2.4.5-.9 1.2-1.7 2-2.3.6-.4 1.2-1 2-.3.5.4.5-.1.7-.3.6-.8 1.2-1.7 1.9-2.5.2-.3.5-.9 1-.5s-.1.7-.3 1c-1.8 2.4-3.2 5.3-3.9 8.3m59 .6c-1.3.7-1.7.5-2.2-1-.3-1 .1-1.8 0-2.9-.7.9-1.3 2-1.8 3-.3.4-.5 1-1.2.8s-.4-.8-.4-1.2c0-1.5.7-2.8 1-4.3-1.3 1-2.4 2.3-3.1 3.8-.3.5-.6 1.1-.9 1.7-.2.2-.4.4-.7.3s-.3-.5-.2-.8c.6-1.3 1.1-2.5 1.6-3.8.1-.4.7-1.2 0-1.2s-1.8-.4-2.1.9c-.3 1.6-1 3.1-2.2 4.3-.3.3-.7.6-1.2.4-.4-.2-.7-.6-.6-1.1 0-1.8.6-3.5 1.7-4.8.1-.2.3-.3.5-.3 1.4.2 2.7-.4 4-.3.7 0 1.4 0 .7 1-.1.2 0 .5 0 1l1.8-1.8c.4-.3.8-.9 1.3-.6s.3.9.2 1.4c-.4 1.2-.7 2.5-.9 3.8.8-1.2 1.3-2.4 2.1-3.3.3-.3.5-.8 1-.6s.2.8.2 1.2c-.2 1-.6 2-.3 3.2.2.7.5 1.1 1.2.9.5-.1.6.1.5.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#030303",
			d: "M79.6 52.2c-.7-.4-1.1-1.1-.9-1.9v-3.4c-1.1 1-2 2.3-2.7 3.8-.2.4-.3 1.1-.9.9s-.3-.8-.3-1.2c.2-1 .5-2.1.8-3.3-1 1.4-2 2.7-3.2 3.9-.7.6-1.5 1.7-2.6 1s-.7-2-.4-3c.5-1.8 1.6-3.4 3-4.5.4-.3.8-.8 1.3-.2.4.4.4 1 .1 1.4-.5 1.1-1.5 1.9-2.6 2.4-1 .6-1.4 1.8-1 2.9.3.5.6.2.9 0 1.2-.9 2.1-1.9 2.9-3.1.4-.7.9-1.3 1.4-1.9.2-.2.5-.5.8-.3s.4.5.3.8c-.1.7-.2 1.3-.3 2.1.6-.7 1.2-1.3 1.7-1.9.2-.3.6-.4 1-.3.4.2.4.5.4.9.1 1.4-.2 2.8.2 4.2 0 .2.1.3.2.4s.6 0 .5.4-.4.1-.6-.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#070707",
			d: "M32.5 26.3c.9-.4 1.3-.1 1 .9-.2.7-.5 1.4-.8 2.4.8-.9 1.3-1.6 1.9-2.3.3-.3.6-.7 1.1-.5s.2.8.1 1.2c-.2 1.1-.5 2.2-.7 3.4.8-.9 1.3-2 2.2-2.8.3-.3.5-.7 1-.4s.2.7.2 1.1c-.2 1.1-.2 2.2.2 3.2.1.2.3.5 0 .6s-.5-.1-.6-.3c-.6-.9-.8-2-.6-3-.7.7-1.3 1.5-1.7 2.4-.2.4-.4.9-1 .7s-.4-.7-.5-1.1c-.1-1.2.4-2.3.6-3.8-1.3 1.6-2.3 2.9-3.4 4.3-.2.3-.3.7-.8.6-.6-.1-.1-.7-.4-1-.6.4-1.3.8-1.9 1.2-.3.3-.7.3-1 .1s-.2-.6-.1-.9c.4-1.3.8-2.6 1.3-3.8.2-.5.8-1 .1-1.6-.2-.2 0-.4.2-.4.3-.1.6 0 .7.3v.1c.1.5.1 1-.1 1.5-.5 1.2-.9 2.4-1.3 3.6 2.4-.6 4.1-2.6 4.5-5 0-.2-.2-.2-.4-.2-.3-.2.2-.3.2-.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040404",
			d: "M52.5 60.6c1 .2 1.5-.5 1.9-1.2.9-2 1.6-4.2 2.1-6.4.4-1.3.7-2.7 1.1-4.3-.9 1.2-1.6 2.2-2.4 3-.2.3-.6.8-1.2.6s-.7-.8-.7-1.3c-.1-2.4.7-4.7 2.1-6.6.4-.5 1-1.2 1.8-.7.7.4 1 1.4.5 2.1l-.1.1c-.3.8-.9 1.5-1.7 2 .5-1 .8-1.7 1.1-2.4.2-.4.1-.9-.3-1.2-.3-.2-.6.2-.8.5-1.5 1.9-2.1 4.3-1.9 6.6.9-.8 1.8-1.8 2.4-2.9.5-.9 1.2-1.7 1.9-2.5.2-.2.5-.3.8-.2s.3.4.2.6c-1.5 3.5-1.9 7.3-3.2 10.8-.3.8-.7 1.6-1.1 2.4-.4 1.1-1.5 1.6-2.6 1.3-.2-.1-.3-.2-.3-.4s.3.1.4.1m-3.4-32.5c-1 .8-1.8 1.9-2.3 3.1-.2.4-.3 1-1 .9s-.5-.8-.5-1.2.3-1.1.1-1.8c-1 1.1-2 2.2-2.8 3.4-.5.6-1 1.4-1.9 1s-1.4-1.4-1.1-2.3c.3-2.2 1.6-4 3.6-5 .4-.2.8-.4 1.2 0s.2.9-.1 1.3c-.6 1.3-1.8 2.2-3.2 2.6-.8.2-.7.7-.8 1.1-.2.5 0 1.1.4 1.4.4.4.7 0 1-.3.8-1 1.5-1.9 2.3-2.9.5-.6 1-1.1 1.6-1.6.2-.2.4-.4.7-.2.2.2.3.5.2.7-.2.6-.2 1.3-.4 2.2.5-.8 1.1-1.6 1.7-2.3.4-.4.8-.7 1.3-.6s.7.8.7 1.2q-.3 2.25 0 4.5c0 .1-.2.3-.3.3s-.3-.1-.4-.2c-.2-.3-.3-.7-.3-1.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0a0a0a",
			d: "M61.8 45.6c-.5-.1-.6.6-.9.3s0-.6.2-.8c.1-.2.3-.5.5-.6.2-.2.5-.5.8-.2.3.2.4.5.3.8-.2 1.1-.7 2.1-.9 3.2.5-.6 1-1.3 1.5-1.9.3-.4.7-.9 1.1-1.2.3-.3.7-.7 1.1-.5s.3.8.2 1.2c-.3 1-.6 2.1-1 3.5.7-1.2 1.5-2.3 2.3-3.3.3-.3.6-.6 1-.4s.4.7.3 1c-.2 1.6-.8 3.2-.3 4.8-1.6-1.4-.6-3.1-.7-4.8-.9 1.1-1.7 2.2-2.3 3.4-.4.6-.6 1.8-1.4 1.4s-.1-1.3.1-2c.4-1.3.8-2.5 1.2-3.9-.9.8-1.8 1.8-2.5 2.8-.8.9-1.5 1.9-2.2 2.8-.2.2-.4.6-.8.4s-.2-.6 0-.9c.8-1.7 1.6-3.3 2.4-5.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0c0c0c",
			d: "M76.8 10.8c-.7-.6-1.7-.8-2.6-.5.4 1.5.6 2.9-.4 4.2-.5.6-1.1 1.2-1.9 1-.7-.2-1.2-.8-1.3-1.6-.1-.2-.1-.4-.2-.6-.4.5-.8 1-1.2 1.4s-1 1.1-1.7.7-1-1.3-.8-2.1c.3-1.2.7-2.4 1.3-3.6-.3-.3-.8.2-1.2-.4 1.9 0 2.1-1.7 3.1-3.1 0 1.2-.6 1.8-.7 2.5.8.2 1.7-.5 2.4.3-.3.4-.8.2-1.2.3-.6.1-1.4 0-1.7.4-.8 1.3-1.2 2.7-1.3 4.1 0 .3.1.7.4.8s.6-.2.8-.4q1.65-1.95 3-4.2c.2-.5.8-.7 1.3-.6.7.1 1.5 0 2.3.1s1.6.3 1.6 1.3m-15.9.2c.4-.2.9-.5 1.3-.8.5-.5.6-1.3.1-1.8-.4-.4-1-.6-1.5-.4s-1 .6-1.5 1c-.6.6-1.1 1.4-.8 2.2s1.1.9 1.9.9c.2 0 .3 0 .5.1 1 .1 2 .3 2.1 1.5-.2 1.2-1.1 2.2-2.3 2.4-.4.1-.9-.1-1.2-.5-.2-.3-.2-.7-.1-1 .1-.2.3-.4.6-.3.5.1.2.3 0 .5s-.1.4.2.4c.5.1 1-.1 1.4-.5.3-.3.7-.7.6-1.2s-.7-.6-1.2-.7c-1.5-.2-2.9-.3-4 1.1q-1.05 1.05-2.4 1.8c-.2.2-.6.3-.9.1s-.4-.6-.2-.9c.6-1.5 1.2-2.9 2-4.3.2-.3 1-.8 0-1.2-.2-.1.1-.3.3-.3.4-.1.8.1.8.5-.1.5-.2.9-.4 1.4-.7 1.3-1.4 2.7-1.9 4.2 1.3-.8 2.5-1.7 3.7-2.6.4-.2.2-.4 0-.7-.5-1-.3-2.2.5-2.9.7-1.1 1.9-1.7 3.1-1.7 1.1.2 1.8 1.2 1.7 2.3-.2.9-1.1 1.5-2.4 1.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#202020",
			d: "M24.1 27.8q.9-1.05 2.1-1.5c.3-.1.7-.1 1 .2.2.3.2.7 0 1-.4.8-1.2 1.4-2.2 1.5.7-.8 1.5-1.2 1.8-2.2-1 .2-1.8.8-2.3 1.6-1 1.3-1.2 2.9-1.5 4.5-.1.6-.1 1.7-.7 1.5-.8-.2-.2-1-.1-1.6.2-1.3.5-2.6.8-4.1-.8.8-1.6 1.7-2.2 2.7-.5.8-1.1 1.6-1.7 2.3-.4.4-1.1.5-1.5.1-.2-.2-.3-.5-.3-.7-.4-2.1 1.3-5.6 3.2-6.6.3-.2.8-.2 1.1 0 .4.3.3.7.1 1.1-.5 1.3-1.6 2.3-2.9 2.9-.8.5-1.2 1.5-.9 2.4.2.5.5.5.8.3.3-.3.6-.6.8-.9 1.1-1.7 2.4-3.3 3.6-4.9.2-.2.3-.7.7-.6.6.1 0 .6.3 1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#090909",
			d: "M82.9 44.1c-2.7-.4-5.4-.6-8.1-.9 1.3-.4 2.7-.5 4-.3 1.2.1 2.3.2 3.4.4.7.2 1.5-.2 1.7-.9.3-.6.6-1.1 1.1-1.5.1.8-.4 1.3-.7 2s-.2.7.4.7c1.7.2 3.4.3 5.1.2.2 0 .4-.1.5.2s-.2.3-.4.4c-1.2.3-2.5.3-3.7.1-3.3-.3-2.4-.7-3.6 2.1-.6 1.2-.8 2.5-.8 3.8.1 1.1.3 1.2 1.3.7.6-.4 1.1-.8 1.5-1.3.5-.7 1.2-1.2 2-1.5-1 1.2-2 2.5-3.1 3.6-.5.5-1.2.7-1.9.4-.6-.4-1-1.1-.9-1.8.4-2.3 1.3-4.3 2.2-6.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#151515",
			d: "M5 25.6c.8.7.7 1.5 1.1 2.3 1.2-.5 2.4-1.3 3.7-.3.5.3.7.9.4 1.3 0 .1-.1.1-.1.2-.1-.7-.6-1.3-1.4-1.3-.7 0-1.4.2-2 .6-.5.3-.3.7-.2 1.2.3 1.6 1.4 2.9 2.8 3.6-1.6.3-2.7-.9-3.8-3.9-.7.6-1.3 1.3-1.8 2-.4.5-.9 1-1.5 1.4s-1.4.3-1.8-.3c-.1-.1-.2-.3-.2-.4-.6-2.3.2-4.7 1.9-6.2.5-.3 1-.5 1.4-.2.5.3.6 1 .3 1.5-.4 1.3-1.4 2.2-2.7 2.6-.3.1-.5.1-.5.5 0 .7-.1 1.4.4 1.9.3.2.7.1 1-.1.1-.1.2-.2.4-.3s.3-.3.4-.4c1.3-1.6 3.6-2.9 2.2-5.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1b1b1b",
			d: "M40.9 13.3c-.6.2-.8 1.2-1.5.8s-.3-1.3-.1-2c.2-.8.5-1.5.8-2.2s0-.8-.6-.7c-.8.2-1.5.6-2.1 1.1-1.2.8-2.2 1.8-3.2 2.9-.3.4-.7.8-1.1 1.1-.4.4-1.1.3-1.5-.1-.2-.2-.3-.4-.3-.7-.1-.7 0-1.4.3-2 1-2.9 2.8-5.4 5-7.5l2.9-2.6c-.3.9-.8 1.6-1.6 2.1-2.3 2-4.1 4.5-5.3 7.3-.4.7-.6 1.5-.6 2.3 0 .7.3.9.9.4l1.2-1.2c1.3-1.5 2.8-2.7 4.5-3.7.5-.4 1.2-.4 1.8-.1.6.5.3 1.2.2 1.8-.3.9-.6 1.8-.8 2.7.4.8.7-.8 1.1.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1d1d1d",
			d: "M12.9 28.7c.5-1 1.3-1.7 2.3-2.2.5-.3 1.1-.3 1.6 0 .4.4.5 1 .3 1.5-.4 1.2-1.1 2.2-1.9 3.1-.4.4-.8.8-1.4.4s-.4-.9-.2-1.5c.4.3 0 1 .6 1 .3 0 .6-.4.9-.7.6-.6 1-1.3 1.3-2.1.2-.4.3-.9-.1-1.2s-.8 0-1.1.2c-1.7 1.2-2.7 3-2.8 5-.3 2.1-.3 4.2.2 6.2.1.3.3.9-.2 1s-.6-.5-.7-.8c-.4-2.1-.5-4.3-.1-6.4 0-1.2.2-2.3.6-3.5.2-.2.4.3.7 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M85.5 24.8c-1.2-.7-2 .1-3.2 2.7.7.5 1.7 0 2.3.7-.5.5-1 .1-1.5 0-.8-.2-1.7.3-1.9 1.1-1.1 2.7-2.7 5.2-3.9 7.9-.1.2-.2.3-.4.3.8-3.2 2.7-5.9 3.9-9-1.3-.1-2.6.1-3.8.7.3-.8 1-1.2 1.8-1.2 1.7.1 3.2-1 3.8-2.6.3-.7.9-1.3 1.6-1.6s1.1-.1 1.3 1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0b0b0b",
			d: "m103.5 27.6.8.1c.2 0 .3.2.3.3v.1c0 .2-.2.2-.3.2-1-.2-1.3.5-1.7 1.3-1.4 2.9-2.6 5.8-3.6 8.9-.1.3-.3.6-.4.9-.2-.7-.1-1.4.2-2 .8-2.6 1.7-5.2 2.9-7.7.1-.2.7-.7-.1-1-.2-.1-.1-.5.2-.5.9-.2 1.1-1.1 1.5-1.8.5-.9 1.1-1.8 2-2.4.4-.2.8-.3 1.2-.2.1 0 .2.2.2.3s0 .2-.1.2h-.1c-1.9.4-2.2 2.1-3 3.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#131313",
			d: "M92.9 13.3c-.7-.8-1.9-1-2.7-.4-1 .5-2 1.2-2.9 1.8-.8.5-1.7 1-2.5.2s-.6-1.6-.3-2.5c.4-1.3 1.2-2.5 2.2-3.5.5-.4 1.2-.9 1.8-.2s.1 1.3-.4 1.7c-.6.6-1.3 1.1-2.1 1.4-.4.1-.7.4-.8.9-.2.6-.4 1.2.2 1.7s1 0 1.5-.2c.9-.5 1.7-1.1 2.6-1.7.8-.5 1.6-.6 2.5-.5.6 0 1.1.5 1.1 1.2-.2 0-.2 0-.2.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0c0c0c",
			d: "M81.8 7.1c-.6.9-1.1 1.9-1.4 3 .6-.6 1.3-1.1 2-1.5.5-.3 1.2-.3 1.7 0 .4.4.5 1 .3 1.6-.4 1.7-1.4 3.1-2.9 4-.7.4-1.6.7-2.1.2s-.7-1.3-.5-2c.4-2 1.3-3.9 2.6-5.5.2-.1.3 0 .3.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#121212",
			d: "M50.6 12.4c-.9 1.4-2.4 2.3-4 2.7-1.7.3-2.8-.9-2.1-2.5.9-2.1 2.8-3.6 5-4 .3-.1.8-.2 1.1.3.2.4.1.9-.3 1.1-1.1 1.2-2.6 1.9-4.3 2.1-.9.1-.8.7-.9 1.2-.1.4.1.9.5 1.1h.3c1.1 0 2.1-.4 3-1.1.5-.5 1.1-.8 1.7-.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0b0b0b",
			d: "M43.6 7.9c.7-1.4 1.6-2.7 2.5-3.9 1.1-1.1 2-1.3 3-.4-2.9 0-3.3 2.4-4.6 4.1.7.3 1.4 0 2 .5-2.4-.6-2.7 1.3-3.5 2.7-1.3 2.4-2.6 4.8-3.8 7.2-.4 0-.3-.2-.2-.5.4-1.5 1.5-2.8 1.9-4.3 1-1.5 1.8-3.1 2.5-4.8-.2-.3 0-.4.2-.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1b1b1b",
			d: "M97.2 31.3c-.5 1.5-2.6 2.7-3.8 2.4-.8-.2-1.3-1-1.1-1.8v-.1c.4-1.9 1.6-3.6 3.4-4.5.4-.2.9-.5 1.3.1s0 .9-.3 1.3c-.6.7-1.4 1.2-2.3 1.5-1.2.2-1.2 1.1-1.3 1.9-.1.6.2.9 1 .8 1.1-.3 2.2-.8 3.1-1.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e0e0e",
			d: "M91.6 32.9c-.6.8-1.7 1.1-2.6.7-.7-.5-1-1.4-.6-2.2.5-1.7 1.6-3.1 3.1-4.1.5-.3 1.2-.6 1.6 0s.1 1.2-.4 1.6q-1.05 1.05-2.4 1.5c-.6.1-1 .6-1.1 1.2-.2 1.1.1 1.5 1.2 1.5.4-.1.7-.5 1.2-.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0d0d0d",
			d: "M86.5 29.1c-1.1 1.1-2.1 2.3-2.8 3.7-.2.3-.3.9-.8.5s0-.7.1-.9c.6-1.1 1.3-2.2 2-3.4l.3-.6c.2-.3-.6-.9.3-.9.7 0 .4.6.6 1 .5-.3.9-.5 1.4-.8s1.1-.5 1.4 0-.4.7-.7 1c-.7-.3-1.2.4-1.8.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e0e0e",
			d: "M107.4 29.1c-1.3.9-1.7 2.4-2.3 3.8-.1.3-.2.7-.4 1s-.3.5-.7.3-.3-.5-.2-.7c.3-.8.6-1.5 1-2.3.5-.9.7-1.8.7-2.8.6-.1.5.4.7.7l.3-.3c.3-.2.7-.5 1.1-.7.2-.2.6-.2.8 0 .3.3 0 .6-.2.8-.1.2-.4.2-.8.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040404",
			d: "M52.5 60.6c-.2.2-.1.3 0 .5-1.1-.2-1.7-1.2-1.5-2.3 0-.2.1-.4.2-.6 0 1 .5 1.9 1.3 2.4"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M86.5 29.1c.2-.4.6-.5.9-.7.5-.5.7 0 .9.3-.4.6-1.1.8-1.8.4" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1d1d1d",
			d: "m12.9 28.7-.3.5-.4-.6c0-.6.3-1.2.8-1.6.2.7-.6 1.2-.1 1.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0a0a0a",
			d: "m43.6 7.9-.3.7c-.6-.2-1.2.4-1.9.1.7-.5 1.4-.8 2.2-.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0c0c0c",
			d: "m81.8 7.1-.3-.3c.3-.7.9-1.2 1.5-1.6-.2.8-.7 1.4-1.2 1.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#121212",
			d: "M73.4 32.3c0 .4-.1.7-.4.7s-.5-.2-.5-.4v-.1c0-.4.1-.6.5-.6.1 0 .3.2.4.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0c0c0c",
			d: "M56.5 8c-.4 0-.8 0-.7-.4s.5-.3.8-.3.6.2.5.5-.4.2-.6.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#292929",
			d: "M40.8 7.4c-.3-.2-.8.2-.8-.3 0-.3.3-.4.6-.4s.7.1.8.4-.4.2-.6.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0c0c0c",
			d: "m39.1 17.6.2.5c-.1.6-.4 1.1-.8 1.5-.1-.7.2-1.4.6-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#060606",
			d: "m122.5 34.2-.3-.2 1.6-1c-.2.7-.5 1.2-1.3 1.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#272727",
			d: "M38.3 43.6c-.3 0-.5-.2-.4-.5s.3-.4.5-.4.5.1.5.4c-.1.3-.4.5-.6.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#434343",
			d: "M29.9 25.3c0 .2-.2.3-.3.3h-.1c-.3-.1-.7 0-.7-.4s.4-.2.6-.2c.1-.1.4 0 .5.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#525252",
			d: "M32.5 26.3c0 .2-.2.4 0 .5-.2.4-.5.6-.9.8 0-.6.4-1.2.9-1.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#282828",
			d: "M70.2 33c-.2 0-.4-.2-.4-.4v-.1c0-.2.2-.4.4-.4s.3.2.3.4c0 .3-.1.5-.3.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#191919",
			d: "M75.6 33c-.2 0-.4-.2-.4-.5 0-.2.1-.4.3-.4h.1c.3 0 .4.2.4.5 0 .2-.2.4-.4.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#030303",
			d: "m79.6 52.2.5-.1-.2-.3c.3 0 .6-.1.9.2 0 .1-.1.2-.1.3-.4.2-.8.2-1.1-.1q.15.15 0 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e0e0e",
			d: "M107.4 29.1c.2-.5.6-.4 1-.2-.3.4-.4 1.3-1 .2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fcfcfc",
			d: "M38 49.4c.2 2.3 0 4.6-.6 6.8-.1.3-.1.6-.4.6s-.4-.3-.5-.6c-.3-.7-.4-1.6-.2-2.3.1-1.7.7-3.2 1.7-4.5m9.2 1.2c.2-1.8 1.2-3.4 2.7-4.4.3-.3.8-.3 1.1 0s0 .5-.1.8c-.8 1.4-1.7 2.8-2.9 3.9-.2.2-.3.4-.6.3s-.1-.4-.2-.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f8f8f8",
			d: "M63.9 28.2c-.7 2-2.3 3-3.6 4.6.2-2.1 1.6-3.9 3.6-4.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#efefef",
			d: "M56.4 29.6c.6-.9 1.4-1.5 2.3-1.9.2-.1.5-.2.6.1 0 .2 0 .4-.1.5-.7.9-1.7 1.4-2.8 1.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fcfcfc",
			d: "M109.3 32.6c.2-1.3.6-2.6 1.3-3.8.1-.1.3-.5.4-.3.2.5 1.1.1 1.1.9s-1.3 3.5-2.1 3.8-.5-.4-.7-.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ddd",
			d: "M72.8 45.2c-.3.8-.9 1.5-1.7 1.8.5-.6 1-1.2 1.7-1.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eee",
			d: "M43.9 26.5c-.6 1.2-1.6 2.2-2.8 2.9.4-1.3 1.5-2.4 2.8-2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fcfcfc",
			d: "M74 11.8c0 .8-.3 1.6-.8 2.2-.3.3-.6.6-1.1.5-.4-.1-.7-.5-.8-1-.2-1.1.1-2.2.8-3 .4-.4.9-.2 1.3-.1.7.3.4 1 .6 1.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f6f6f6",
			d: "M18.4 29.7c.4-1.3 1.3-2.3 2.5-2.9 0 1.2-.8 2.1-2.5 2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f8f8f8",
			d: "M.8 29.4c.1-1.1.7-2.2 1.6-2.9.2-.2.5-.3.8-.1s.1.4 0 .6c-.6 1-1.4 1.9-2.4 2.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f1f1f1",
			d: "M86 11.2c.1-.8.6-1.5 1.2-2 .2-.2.5-.4.7-.2s0 .6-.2.8c-.6.6-1.2 1-1.7 1.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fbfbfb",
			d: "M80.1 14.1c-.5 0-.7-.4-.5-.6.8-1.4 1.4-3.2 3-4 .3-.2.7-.5 1.1-.2s.2.8 0 1.1c-.5 1.6-1.6 2.9-3.1 3.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f5f5f5",
			d: "M45.9 11.4c1-1.2 2.3-2 3.8-2.3-.8 1.3-2.2 2.2-3.8 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e8e8e8",
			d: "M94 29.6c.5-.9 1.3-1.6 2.3-1.9-.3.9-.8 1.4-2.3 1.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#efefef",
			d: "M89.9 30c.8-1.1 1.4-2.1 2.7-2.3-.4 1-.8 1.4-2.7 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#010101",
			d: "M8.7 56.3Q7.65 54.8 7.2 53c-.2-2.3.9-4.6 2.8-6 1.3-.8 3.1-.7 4.3.3.5.6 1 1.2 1.4 1.9.8 1 1.7.9 2.3-.3.5-1 .8-2 1.3-3 .2-.7.6-1.2 1.1-1.7.6-.5 1.4-.5 1.9.1.4.4.7.9.9 1.4.5 1.6.9 3.3 1.1 5 .2 2.2-.6 4.3-2.3 5.7a9.1 9.1 0 0 1-6.3 2.5c-2.1.2-4.3-.3-6-1.6-.3-.2-.7-.6-1-1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eefafa",
			d: "M8.4 54.9c1.2 1.2 2.9 1.8 4.6 1.6.9 0 1.7-.6 2-1.5.1-.5.5-.9 1.1-1 1.7-.5 3.1-1.9 3.7-3.6.3-1 .8-1.9 1.4-2.7s1.2-.8 1.8-.4c.1.1.2.2.2.4.2 1.2.5 2.4.6 3.6.1 2.5-1.3 4.8-3.5 6-2.8 1.6-6.2 1.8-9.2.5-1.2-.6-2.2-1.6-2.7-2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#bae8fe",
			d: "M22.9 46.5c-.9-.3-1.6 0-2.3.9-.5.8-1 1.6-1.3 2.5-.5 1.7-1.9 3-3.5 3.5-.6.2-1.1.7-1.3 1.3-.1.8-.8 1.3-1.6 1.3-2 .2-3.7-.5-4.5-2.3-1-2.4 0-5.1 2.2-6.4 1.2-.6 2.7-.3 3.6.7.4.5.8 1.2 1.2 1.7.9 1.1 2.2 1 3-.4q.6-1.05.9-2.1c.3-.7.6-1.5 1-2.1.7-1 1.5-1.1 2.1-.1.3.5.5 1 .5 1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#010101",
			d: "M21.6 53.4c-.6.4-1.3.7-2 .8-.3.1-.6 0-.8-.3-.1-.3 0-.5.2-.7.2-.3.4-.5.7-.7.4-.4.8-.9 1-1.4.1-.6.6-1 1.2-1.1.7 0 1.2.5 1.2 1.2 0 .2 0 .4-.1.5-.3.6-.8 1.2-1.4 1.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#010102",
			d: "M9.8 52.4c-.3-.4-.5-.9-.4-1.4-.1-1 .4-2 1.2-2.6.3-.3.9-.3 1.3 0s.5.8.3 1.2c-.3.5-.4 1.1-.4 1.7 0 .2 0 .4-.1.6-.1.4-.2.8-.7 1s-1-.3-1.2-.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fcfdfe",
			d: "M9.1 53.1c.2 0 .2.1.3.2.6 1.1 1.9 1.6 3 1.1 0 0 .1 0 .1-.1.3-.1.6-.3.8-.6.5-.7 1.4-1.1 2.2-1 0 .2-.1.2-.3.3-.6.2-1.1.7-1.4 1.2-.7.9-1.9 1.3-3 .8-.8-.2-1.4-.8-1.7-1.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fafdfe",
			d: "M18.6 49.9s0-.1 0 0c.7-1.4 1.4-2.8 1.9-4.2.1-.3.4-.5.7-.7.2-.1.5-.1.7 0s.3.2.2.4-.3.1-.4.2c-.3 0-.6.2-.8.5-.4.6-.7 1.2-1 1.8-.3.7-.7 1.4-1.2 2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b9e8fd",
			d: "M21.3 53c-.5.3-1.1.6-1.7.7-.1 0-.3.1-.4-.1s.1-.3.2-.4c.3-.3.6-.5.8-.8.4-.4.6-.8.8-1.3 0-.1.1-.3.2-.4.1-.4.5-.6.9-.5s.5.5.4.9c-.2.8-.6 1.4-1.2 1.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#edf9f9",
			d: "M10.7 48.8c.2-.2.5-.3.8-.1s.2.5.1.8c-.3.6-.5 1.3-.5 2 0 .3 0 .8-.4.8s-.6-.3-.7-.6c-.3-1 0-2.1.7-2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#010101",
			d: "M108 19.1c-4.5 0-7.2-3.2-7.9-7-.5-2.6.4-5.2 2.4-7 2-1.9 4.3-3.5 6.8-4.8.8-.6 1.9-.4 2.4.4.1.1.1.2.1.2 1.4 2.5 2.7 4.9 2.9 7.9.2 2.2-.1 4.3-.8 6.4-.9 2.4-3.3 4-5.9 3.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eefafa",
			d: "M107.6 2.1c-.4.7-.8 1.4-1.1 2.1-.8 1.7-.6 3.8.7 5.2.7.8 1.4 1.7 2 2.6 1.1 1.9.8 4.2-.7 5.8-.4.4-1 .6-1.6.5-2.5-.3-4.6-1.9-5.4-4.2-1.4-3-.6-6.5 1.8-8.6.4-.4.9-.8 1.4-1.2.9-.8 1.9-1.5 2.9-2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#bae8fe",
			d: "M108.7 18.5c1.8-1.8 2.2-4.5 1-6.7-.4-.7-.9-1.4-1.4-2-3.1-3-1.2-6.4 1-8.3 1.3-1.1 1.8-.9 2.5.6.9 1.6 1.6 3.2 2.1 5 .7 2.6.5 5.4-.5 7.9-.8 1.9-2.6 3.3-4.7 3.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#020303",
			d: "M105.5 15c-.9 0-1.6-.8-1.6-1.7s.6-1.6 1.5-1.7c1 0 1.7.7 1.8 1.7 0 .8-.8 1.6-1.7 1.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fbfdfe",
			d: "M111.8 15.6c-.2-.2 0-.4.1-.6.8-1.5 1.1-3.2.8-4.8-.1-.9-.3-1.9-.5-2.8 0-.2 0-.5.2-.6s.4.1.6.3c.5.9.7 1.9.7 2.9 0 1.7-.4 3.5-1.3 5-.3.3-.3.6-.6.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#020203",
			d: "M108.6 5c0-.8.5-1.6 1.2-2 .4-.3.9-.2 1.1.2.1.1.2.3.2.5.1.4.1.9.2 1.3.2.6 0 1.3-.6 1.7-.4.4-1 .5-1.5.3-.3-.2-.6-.9-.6-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b8e6fb",
			d: "M104.6 13.3c0-.6.4-1.1.9-1.1.6.1 1 .6 1.1 1.1-.1.5-.5 1-1.1 1.1-.5-.1-1-.5-.9-1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ebf7f7",
			d: "M109.2 5.5c0-.7.3-1.3.7-1.8.1-.1.3-.3.4-.2.2.1.2.3.2.5 0 .4.1.9.2 1.3.1.6-.2 1.2-.8 1.2s-.6-.6-.7-1"
		})
	]
});
export default SvgLettering;
